import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { CustomNavbar } from '../CustomNavbar/customnabar'
import { Sidenav } from '../SideNav/Sidenav'
import HeaderRow from './Widgets/HeaderRow/HeaderRow'
import TransactionValue from './Widgets/TrasactionValue/TransactionValue'
import { CustomerPage } from '../../APIs/ServiceClass/CustomerPage'
import { BiEditAlt } from 'react-icons/bi';
import { AiOutlineSend } from 'react-icons/ai'
import { Modal, Box } from '@mui/material';
import { Modalstyle } from '../Modals/UploadImage/UploadImageModalStyle';
import {Dialog, TextField} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Loader from "../Loader/Loader";
import {CircularProgress} from '@mui/material'
import Layout from '../../ReuseComponent/Layout/Layout'
import { nFormatter } from '../../APIs/Metrics/Metrics'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'



export const CustomerSummary = ({ auth }) => {

    const location = useLocation();
    const summary = new CustomerPage();
    const navigate = useNavigate()

    const [customer, setCustomer] = useState(null);
    const [chart, setChart] = useState([]);


    const [signOpen, setSignOpen] = useState(false);
    const [bvn, setBvn] = useState(location.state.bvn);
    const [openEditBvn, setOpenEditBvn] = useState(false)
    const [bvnSuccess, setBvnSuccess] = useState(false)

    const [isUpdating, setIsUpdating] = useState(false);
    const [msg, setMsg] = useState({failed:false, msg:""});

    const [editProfile, setEditProfile] = useState(false)
    const [reloadPage, setReloadPage] = useState(false)

    const [editdata, setEditData] = useState({
        firstName: location?.state?.f_name,
        lastName: location?.state?.l_name,
        email: location?.state?.email,
        address: location?.state?.home_address,
        phone: location?.state?.phone,
        gender: location?.state?.gender == 0 ? 'Male' : 'Female'
    })

    const [isLoadingUpdateProfile, setIsLoadingUpdateProfile] = useState(false)

    const admin = JSON.parse(window.localStorage.getItem('auth')) 

    //Dialog
    const [openD, closeD] = useState(false);

    const UpdateBvn = ()=>{
        const state = location.state;
        if(bvn !== state.bvn.toString()){
            setMsg({failed:false, msg:""});
            setIsUpdating(true);
            const data = {
                "user_id": state.id.toString(), "f_name": state.f_name, 
                "m_name": state.m_name, "l_name": state.l_name, "bvn": bvn,
                "phone": state.phone, "email": state.email
            }
            summary.updateBVN(data).then((value)=>{
                window.localStorage.setItem("token", value.data.token);
                setIsUpdating(false); 
                setSignOpen(false); 
                setOpenEditBvn(false)
                setBvnSuccess(true)
            }).catch((error)=>{
                console.log(error); 
                setIsUpdating(false);
                if (error.response.status === 401) navigate('/login')
            });
        }else{
            setMsg({msg:'No changes made..', failed:true})
        }
    }

    const loadUserInfo = () => {
        summary.getCustomerInfo(location.state.id.toString())
        .then((value) => {
            const newData = value.data.data.transInAndOut
            setCustomer(value.data.data); setChart([
                ...[
                    ...newData
                ].reverse()])
        }).catch((error) => {
            console.log(error);
            if (error.response.status === 401) navigate('/login')
        });
    }

    useEffect(() => {
        loadUserInfo()
    }, [reloadPage]);

    const handleSubmitEditProfile = () => {
        const data = {
            admin_id: admin.id,
            user_id : location?.state?.id,
            f_name : editdata?.firstName,
            m_name : location?.state?.m_name,
            l_name : editdata?.lastName,
            phone : editdata?.phone,
            email : editdata?.email,
            image : location?.state?.image,
            gender: editdata?.gender
        }


        setIsLoadingUpdateProfile(true)
        summary.adminUpdateUser(data)
        .then(val => {
            toast.success('User info updated')
            setIsLoadingUpdateProfile(false)
            setReloadPage(!reloadPage)
        }).catch(err => {
            setIsLoadingUpdateProfile(false)
            toast.error(err.response?.data?.message)
        })
    }

    const handleCancelEditProfile = () => {
        setEditProfile(false)
        setEditData({
            firstName:location?.state?.f_name,
        lastName: location?.state?.l_name,
        email: location?.state?.email,
        address: location?.state?.home_address,
        phone: location?.state?.phone,
        gender: location?.state?.gender  == 0 ? 'Male' : 'Female'
        })
    }


    return (
        <div>
            <Layout label={'Customer details'}>

                <div style={{ width: "80vw", display: "inline-flex", justifyContent: "center" }}>

                    <div  style={{ width: "100%" }}>

                        <HeaderRow img={location.state.image} dta={location.state} customer={customer} />

                        <div className='edit-bvn' style={{ marginTop: "5vh" }}>
                            <p style={{ marginBottom: "10px" }}>Edit User Details</p>
                            <button onClick={() => setSignOpen(true)} style={{ padding: "5px 10px", backgroundColor: "white", border: "1px solid #608E75" }}>
                                <BiEditAlt /> Edit</button>
                        </div>



                        {customer !== null && <TransactionValue transCount={chart} />}

                        <div className='details_card' style={{ width: "100%" }}>

                            <div className='in' style={{ width: "100%", padding: "0px" }}>

                                <p>Personal Details</p>

                                <div style={{marginTop: '10px'}}>
                                    {!editProfile && <button onClick={() => setEditProfile(true)} style={{ padding: "5px 10px", backgroundColor: "white", border: "1px solid #608E75", cursor: 'pointer' }}>
                                    <BiEditAlt /> Edit Profile</button>}

                                    {editProfile && <button onClick={handleCancelEditProfile} style={{ padding: "5px 10px", backgroundColor: "white", border: "1px solid #608E75", cursor: 'pointer' }}>
                                    Cancel</button> }
                                </div>

                                <div className='profile-grid' style={{ columnGap: "0px" }}>

                                    <div className='container' style={{ width: "85%" }}>
                                        <div><label>First Name:</label></div>
                                        {!editProfile && <div className='field' style={{ fontSize: "14px" }}>{customer?.f_name}</div>}
                                        {editProfile &&<div contentEditable onInput={(e)=> setEditData({...editdata, firstName: e.target.textContent})} className='field' style={{ fontSize: "14px" }}>{customer?.f_name}</div>}

                                    </div>

                                    <div className='container' style={{ width: "85%" }}>
                                        <div><label>Last Name:</label></div>
                                        {!editProfile && <div className='field' style={{ fontSize: "14px" }}>{customer?.l_name}</div>}
                                        {editProfile && <div contentEditable onInput={(e)=> setEditData({...editdata, lastName: e.target.textContent})} className='field' style={{ fontSize: "14px" }}>{customer?.l_name}</div>}
                                    </div>

                                    <div className='container' style={{ width: "85%" }}>
                                        <div><label>Email:</label></div>
                                        {!editProfile && <div className='field' style={{ fontSize: "14px" }}>{customer?.email}</div>}
                                        {editProfile && <div contentEditable onInput={(e)=> setEditData({...editdata, email: e.target.textContent})} className='field' style={{ fontSize: "14px" }}>{customer?.email}</div>}

                                    </div>

                                    <div className='container' style={{ width: "85%" }}>
                                        <div><label>Gender:</label></div>
                                        {!editProfile && <div className='field' style={{ fontSize: "14px" }}>{customer?.gender == "0" ? "Male" : customer?.gender == 1 ? "Female" : 'None'}</div>}
                                        {editProfile && <div contentEditable onInput={(e)=> setEditData({...editdata, gender: e.target.textContent})} className='field' style={{ fontSize: "14px" }}>{customer?.gender === "0" ? "Male" : "Female"}</div>}

                                    </div>

                                    <div className='container' style={{ width: "85%" }}>
                                        <div><label>Phone Number:</label></div>
                                        {!editProfile && <div className='field' style={{ fontSize: "14px" }}>{customer?.phone}</div>}
                                        {editProfile && <div contentEditable onInput={(e)=> setEditData({...editdata, phone: e.target.textContent})} className='field' style={{ fontSize: "14px" }}>{customer?.phone}</div>}
                                    </div>

                                    <div className='container' style={{ width: "85%" }}>
                                        <div><label>Bvn:</label></div>
                                        <div className='field'  style={{
                                             padding: openEditBvn === true ? 0 : '1.3rem',
                                             fontSize: "14px", 
                                             display: 'flex', 
                                             justifyContent: 'space-between',
                                             alignItems: 'center' 
                                        }}> 
                                            {openEditBvn && <TextField id="outlined-basic" value={bvn}  variant="standard" sx={{borderBottom:'none', }} onChange={(e)=>{setBvn(e.target.value)}}/>}
                                            {!openEditBvn && <p>{bvn}</p>  }

                                            {!openEditBvn && <BiEditAlt style={{cursor:'pointer', fontSize:'18px', marginRight: openEditBvn === true ? '1.3rem': 0}} onClick={()=>setOpenEditBvn(!openEditBvn)}/> }
                                            {openEditBvn && <AiOutlineSend style={{cursor:'pointer', fontSize:'18px', marginRight: openEditBvn === true ? '1.3rem': 0}} onClick={()=>closeD(true)}/> }
                                        </div>
                                    </div>

                                    <div className='container' style={{ width: "85%" }}>
                                        <div><label>Address:</label></div>
                                        {!editProfile && <div className='field' style={{ fontSize: "14px" }}>{customer?.home_address}</div>}
                                        {editProfile && <div contentEditable onInput={(e)=> setEditData({...editdata, address: e.target.textContent})} className='field' style={{ fontSize: "14px" }}>{customer?.home_address}</div>}

                                    </div>


                                    <div className='container' style={{ marginTop: "4vh", color: "black", padding: "20px 10px" }}>
                                        {"Created On: " + new Date(customer?.updated_at).toString().substring(0, 25)}
                                    </div>

                                    {editProfile && <div style={{ display: "inline-flex", justifyContent: "flex-end", margin: "30px" }}>
                                        {!isLoadingUpdateProfile && <button style={{cursor: 'pointer'}} onClick={handleSubmitEditProfile} className='sub-btn'>Submit</button>}
                                        {isLoadingUpdateProfile && <div style={{display: 'flex', justifyContent: 'center'}}><Loader/></div> }
                                    </div>}

                                </div>

                            </div>


                        </div>


                        <Modal
                            open={signOpen}
                            onClose={() => setSignOpen(false)}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description">
                            <Box sx={Modalstyle}>

                                <center>
                                    <section className="datepicker" style={{ width: "70%" }}>



                                        <div className="form-input" style={{ width: "100%" }}>
                                            <label>Update BVN</label>
                                            <input type="text" onChange={(e)=>setBvn(e.target.value)} maxLength={11} style={{ padding: "15px" }} value={bvn} />
                                        </div>

                                        {!isUpdating ? <div style={{ width: "100%" }}>
                                            <button 
                                            onClick={()=>closeD(true)}
                                            style={{ padding: "15px" }} className='btn_'>Apply Changes</button>
                                        </div>: <div class="sk-bounce">
                                <div class="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                <div class="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                            </div>}


                            <p style={{color:(msg.failed===true)?"red":"green",fontSize:"14px",marginTop:"20px"}}>
                                {msg.msg}</p>
                                        



                                    </section>
                                </center>

                            </Box>
                        </Modal>


                    </div>

                    <Dialog
                        open={openD}
                        onClose={()=>{closeD(false); setBvnSuccess(false)}}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogContent>
                            <center>
                                <div style={{ width: "200px", padding: "30px" }}>

                                    <p className="dialog-text">Are you sure you want to edit this user's BVN</p>
                                    <br></br>

                                    {!bvnSuccess && <div style={{width:"100%",display:"inline-flex",justifyContent:"space-between"}}>
                                        <button
                                            onClick={()=>closeD(false)}
                                        style={{padding:"10px 20px",border:"1px solid #608E75",
                                        color:"#608E75", backgroundColor:"white"
                                    }}>No</button>
                                        
                                    {!isUpdating && <button
                                    onClick={()=>{UpdateBvn()}}
                                    style={{padding:"10px 20px",border:"none",
                                    color:"white", backgroundColor:"#608E75"
                                    }}>Yes
                                    </button> }
                                    {isUpdating && <CircularProgress  /> }
                                    </div> }
                                    
                                    {bvnSuccess && <button style={{padding:"10px 20px",border:"none",
                                    color:"white", backgroundColor:"#608E75"
                                    }} onClick={()=> {setBvnSuccess(false); closeD(false)}}>Successfull</button> }

                                </div>
                            </center>
                        </DialogContent>
                    </Dialog>


                </div>
            </Layout>
        </div>
        
    )
}
